import * as React from "react";
import styles from "./EditCompWrap.module.css"
import CtxComp from "./CtxComp"

import Moveable, { MoveableManagerInterface, Renderer } from "react-moveable";
import MoveableHelper from "moveable-helper";

export default function EditCompWrap(props) {

    const [helper] = React.useState(() => {
        return new MoveableHelper();
    })
    const [pos, setPosition] = React.useState([-10, -10])
    const targetRef = React.useRef(null);
    const [displayEditFlag, setDisplay] = React.useState(1)
    const [manipulateFlag, setManipulateFlag] = React.useState(false)
    //local variable
    var timeInst = null
    //handler
    const manipulateStartHandler = (e) => { setManipulateFlag(true) }
    const manipulateEndHandler = (e) => { setManipulateFlag(false) }
    const hoverEnter = (e) => {
        setDisplay(1)
        if (timeInst)
            clearTimeout(timeInst)
    }
    const hoverLeave = (e) => {
        if (manipulateFlag)
            return
        if (timeInst)
            clearTimeout(timeInst)
        timeInst = setTimeout(() => { setDisplay(0) }, 1000)
    }

    const hookTargetInfo = (e) => {
        const { x: rectX, y: rectY, width: rectWidth, height: rectHeight } = e.target.getBoundingClientRect()
        const x = rectX - 150
        const y = rectY - 120
        setPosition([x, y])
    }
    const deleteHandler = (e) => {
        if (props.deleteCallback)
            props.deleteCallback(props.id)
    }

    const deleteStyle = {
        "visibility": (displayEditFlag) ? "visible" : "hidden",
        "top": `${pos[1]}px`,
        "left": `${pos[0]}px`,
    }
    return (
        <div className="container" onMouseEnter={hoverEnter} onMouseLeave={hoverLeave}>
            <div className={styles.targetStyle} ref={targetRef}>
                <CtxComp {...props} />
            </div>
            <Moveable
                zoom={displayEditFlag}
                target={targetRef}
                draggable={true}
                scalable={true}
                rotatable={true}
                onDragStart={(e) => { helper.onDragStart(e); }}
                onDrag={(e) => { hookTargetInfo(e); helper.onDrag(e); }}
                onScale={(e) => { hookTargetInfo(e); helper.onScale(e); }}
                onScaleStart={(e) => { manipulateStartHandler(e); helper.onScaleStart(e) }}
                onScaleEnd={(e) => { manipulateEndHandler(e); }}
                onRotateStart={(e) => { manipulateStartHandler(e); helper.onRotateStart(e) }}
                onRotateEnd={(e) => { manipulateEndHandler(e); }}
                onRotate={(e) => { hookTargetInfo(e); helper.onRotate(e); }}
            />
            <div className={styles.deleteStyle} style={deleteStyle} onClick={deleteHandler}>X</div>
        </div >);
}
